import styled, { css } from 'styled-components';

export const Overlay = styled.div`
  ${() => {
    // const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      width: 100%;
      height: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      ${({ playerState }) =>
        (playerState === 0 || playerState === 2) &&
        `
        display: none;
      `}
      ${(props) => props?.styleOverrides}
    `;
  }}
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;

  .ytp-large-play-button {
    display: none;
  }
`;
